<ng-template #buttons>
  <div class="change-password__actions">
    <ut-button variant="secondary" (clicked)="cancel.emit()">
      {{ 'button.cancel' | translate }}
    </ut-button>
    <ut-button variant="primary" [disabled]="!activeForm?.valid" (clicked)="submit()">
      {{ 'login.continue' | translate }}
    </ut-button>
  </div>
</ng-template>

@if(!loading) {
  @if(authform) {
    <form [formGroup]="authform">
      <app-input [control]="authform.controls.oldPassword" name="old_password" placeholder="password.old"
                 type="password"></app-input>
      <app-input [control]="authform.controls.newPassword" name="new_password" placeholder="password.new"
                 type="password"></app-input>
      <ng-container *ngTemplateOutlet="buttons"></ng-container>
    </form>
  } @else {
    <form [formGroup]="unauthform">
      <app-input [control]="unauthform.controls.password" name="password.new" placeholder="password.label"
                 type="password"></app-input>
      <ng-container *ngTemplateOutlet="buttons"></ng-container>
    </form>
  }
}
